export enum RatingViewVersionDefaults {
  VERSION_2015 = 1,
  VERSION_2025 = 2
}
